
import React, { Component } from 'react';

export default class Contact extends Component {
    state = {
        value: 0,
      };
    render(){
        return(
            <div>
                    <h5>Contact us</h5>
                    <br /> <br /> <br />
               Contact us using one of the methods below to get the ball rolling!<br />
               shuaibam1@gmail.com or on +(44) (0) 75 929 355 62.<br />
               <br /><br />
               We would love to hear from you to take through our demo or even send you templates for your const site design
               and build.
            </div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/Contact.js